'use client'
import { useTranslations } from 'next-intl'
import { DetailPageHeader } from '@/components/header/detail-page-header'
import { FLOWS_PATH } from '@/lib/flow-templates/slug'
/**
 * The app-shell header for a flow page: Flows / {Brand} flow, in the
 * reader's language (`flows` catalog). The loading shell passes
 * `brandName={null}`, which holds `Flows`.
 */
export function FlowHeaderInjector({
  brandName,
}: {
  brandName: string | null
}) {
  const t = useTranslations('flows')
  return (
    <DetailPageHeader
      parentLabel={t('title')}
      parentHref={FLOWS_PATH}
      title={brandName === null ? null : t('detail.headerTitle', { brandName })}
    />
  )
}
